'use client';
"use strict";

var _excluded = ["children", "className"],
  _excluded2 = ["label", "placement", "spacing", "children", "className", "__css"],
  _excluded3 = ["isDisabled", "isLoading", "isActive", "children", "leftIcon", "rightIcon", "loadingText", "iconSpacing", "type", "spinner", "spinnerPlacement", "className", "as"],
  _excluded4 = ["size", "colorScheme", "variant", "className", "spacing", "isAttached", "isDisabled", "orientation"],
  _excluded5 = ["icon", "children", "isRound", "aria-label"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Button: function Button() {
    return _Button;
  },
  ButtonGroup: function ButtonGroup() {
    return _ButtonGroup;
  },
  ButtonSpinner: function ButtonSpinner() {
    return _ButtonSpinner;
  },
  IconButton: function IconButton() {
    return _IconButton;
  },
  useButtonGroup: function useButtonGroup() {
    return _useButtonGroup;
  }
});
module.exports = __toCommonJS(src_exports);

// src/button.tsx
var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");
var import_system3 = require("@chakra-ui/system");
var import_shared_utils3 = require("@chakra-ui/shared-utils");
var import_react4 = require("react");

// src/button-context.ts
var import_react_context = require("@chakra-ui/react-context");
var _ref2 = (0, import_react_context.createContext)({
    strict: false,
    name: "ButtonGroupContext"
  }),
  _ref3 = _slicedToArray(_ref2, 2),
  ButtonGroupProvider = _ref3[0],
  _useButtonGroup = _ref3[1];

// src/button-icon.tsx
var import_system = require("@chakra-ui/system");
var import_shared_utils = require("@chakra-ui/shared-utils");
var import_react = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
function ButtonIcon(props) {
  var children = props.children,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var _children = (0, import_react.isValidElement)(children) ? (0, import_react.cloneElement)(children, {
    "aria-hidden": true,
    focusable: false
  }) : children;
  var _className = (0, import_shared_utils.cx)("chakra-button__icon", className);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.span, _objectSpread(_objectSpread({
    display: "inline-flex",
    alignSelf: "center",
    flexShrink: 0
  }, rest), {}, {
    className: _className,
    children: _children
  }));
}
ButtonIcon.displayName = "ButtonIcon";

// src/button-spinner.tsx
var import_spinner = require("@chakra-ui/spinner");
var import_system2 = require("@chakra-ui/system");
var import_shared_utils2 = require("@chakra-ui/shared-utils");
var import_react2 = require("react");
var import_jsx_runtime2 = require("react/jsx-runtime");
function _ButtonSpinner(props) {
  var label = props.label,
    placement = props.placement,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
    _props$children = props.children,
    children = _props$children === void 0 ? /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_spinner.Spinner, {
      color: "currentColor",
      width: "1em",
      height: "1em"
    }) : _props$children,
    className = props.className,
    __css = props.__css,
    rest = _objectWithoutProperties(props, _excluded2);
  var _className = (0, import_shared_utils2.cx)("chakra-button__spinner", className);
  var marginProp = placement === "start" ? "marginEnd" : "marginStart";
  var spinnerStyles = (0, import_react2.useMemo)(function () {
    return _objectSpread(_defineProperty(_defineProperty(_defineProperty({
      display: "flex",
      alignItems: "center",
      position: label ? "relative" : "absolute"
    }, marginProp, label ? spacing : 0), "fontSize", "1em"), "lineHeight", "normal"), __css);
  }, [__css, label, marginProp, spacing]);
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.div, _objectSpread(_objectSpread({
    className: _className
  }, rest), {}, {
    __css: spinnerStyles,
    children: children
  }));
}
_ButtonSpinner.displayName = "ButtonSpinner";

// src/use-button-type.tsx
var import_react3 = require("react");
function useButtonType(value) {
  var _ref4 = (0, import_react3.useState)(!value),
    _ref5 = _slicedToArray(_ref4, 2),
    isButton = _ref5[0],
    setIsButton = _ref5[1];
  var refCallback = (0, import_react3.useCallback)(function (node) {
    if (!node) return;
    setIsButton(node.tagName === "BUTTON");
  }, []);
  var type = isButton ? "button" : void 0;
  return {
    ref: refCallback,
    type: type
  };
}

// src/button.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var _Button = (0, import_system3.forwardRef)(function (props, ref) {
  var group = _useButtonGroup();
  var styles = (0, import_system3.useStyleConfig)("Button", _objectSpread(_objectSpread({}, group), props));
  var _ref6 = (0, import_system3.omitThemingProps)(props),
    _ref6$isDisabled = _ref6.isDisabled,
    isDisabled = _ref6$isDisabled === void 0 ? group == null ? void 0 : group.isDisabled : _ref6$isDisabled,
    isLoading = _ref6.isLoading,
    isActive = _ref6.isActive,
    children = _ref6.children,
    leftIcon = _ref6.leftIcon,
    rightIcon = _ref6.rightIcon,
    loadingText = _ref6.loadingText,
    _ref6$iconSpacing = _ref6.iconSpacing,
    iconSpacing = _ref6$iconSpacing === void 0 ? "0.5rem" : _ref6$iconSpacing,
    type = _ref6.type,
    spinner = _ref6.spinner,
    _ref6$spinnerPlacemen = _ref6.spinnerPlacement,
    spinnerPlacement = _ref6$spinnerPlacemen === void 0 ? "start" : _ref6$spinnerPlacemen,
    className = _ref6.className,
    as = _ref6.as,
    rest = _objectWithoutProperties(_ref6, _excluded3);
  var buttonStyles = (0, import_react4.useMemo)(function () {
    var _focus = _objectSpread(_objectSpread({}, styles == null ? void 0 : styles["_focus"]), {}, {
      zIndex: 1
    });
    return _objectSpread(_objectSpread({
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none"
    }, styles), !!group && {
      _focus: _focus
    });
  }, [styles, group]);
  var _useButtonType = useButtonType(as),
    _ref = _useButtonType.ref,
    defaultType = _useButtonType.type;
  var contentProps = {
    rightIcon: rightIcon,
    leftIcon: leftIcon,
    iconSpacing: iconSpacing,
    children: children
  };
  return /* @__PURE__ */(0, import_jsx_runtime3.jsxs)(import_system3.chakra.button, _objectSpread(_objectSpread({
    ref: (0, import_react_use_merge_refs.useMergeRefs)(ref, _ref),
    as: as,
    type: type != null ? type : defaultType,
    "data-active": (0, import_shared_utils3.dataAttr)(isActive),
    "data-loading": (0, import_shared_utils3.dataAttr)(isLoading),
    __css: buttonStyles,
    className: (0, import_shared_utils3.cx)("chakra-button", className)
  }, rest), {}, {
    disabled: isDisabled || isLoading,
    children: [isLoading && spinnerPlacement === "start" && /* @__PURE__ */(0, import_jsx_runtime3.jsx)(_ButtonSpinner, {
      className: "chakra-button__spinner--start",
      label: loadingText,
      placement: "start",
      spacing: iconSpacing,
      children: spinner
    }), isLoading ? loadingText || /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_system3.chakra.span, {
      opacity: 0,
      children: /* @__PURE__ */(0, import_jsx_runtime3.jsx)(ButtonContent, _objectSpread({}, contentProps))
    }) : /* @__PURE__ */(0, import_jsx_runtime3.jsx)(ButtonContent, _objectSpread({}, contentProps)), isLoading && spinnerPlacement === "end" && /* @__PURE__ */(0, import_jsx_runtime3.jsx)(_ButtonSpinner, {
      className: "chakra-button__spinner--end",
      label: loadingText,
      placement: "end",
      spacing: iconSpacing,
      children: spinner
    })]
  }));
});
_Button.displayName = "Button";
function ButtonContent(props) {
  var leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    children = props.children,
    iconSpacing = props.iconSpacing;
  return /* @__PURE__ */(0, import_jsx_runtime3.jsxs)(import_jsx_runtime3.Fragment, {
    children: [leftIcon && /* @__PURE__ */(0, import_jsx_runtime3.jsx)(ButtonIcon, {
      marginEnd: iconSpacing,
      children: leftIcon
    }), children, rightIcon && /* @__PURE__ */(0, import_jsx_runtime3.jsx)(ButtonIcon, {
      marginStart: iconSpacing,
      children: rightIcon
    })]
  });
}

// src/button-group.tsx
var import_system4 = require("@chakra-ui/system");
var import_shared_utils4 = require("@chakra-ui/shared-utils");
var import_react5 = require("react");
var import_jsx_runtime4 = require("react/jsx-runtime");
var attachedStyles = {
  horizontal: {
    "> *:first-of-type:not(:last-of-type)": {
      borderEndRadius: 0
    },
    "> *:not(:first-of-type):not(:last-of-type)": {
      borderRadius: 0
    },
    "> *:not(:first-of-type):last-of-type": {
      borderStartRadius: 0
    }
  },
  vertical: {
    "> *:first-of-type:not(:last-of-type)": {
      borderBottomRadius: 0
    },
    "> *:not(:first-of-type):not(:last-of-type)": {
      borderRadius: 0
    },
    "> *:not(:first-of-type):last-of-type": {
      borderTopRadius: 0
    }
  }
};
var gapStyles = {
  horizontal: function horizontal(spacing) {
    return {
      "& > *:not(style) ~ *:not(style)": {
        marginStart: spacing
      }
    };
  },
  vertical: function vertical(spacing) {
    return {
      "& > *:not(style) ~ *:not(style)": {
        marginTop: spacing
      }
    };
  }
};
var _ButtonGroup = (0, import_system4.forwardRef)(function ButtonGroup2(props, ref) {
  var size = props.size,
    colorScheme = props.colorScheme,
    variant = props.variant,
    className = props.className,
    _props$spacing2 = props.spacing,
    spacing = _props$spacing2 === void 0 ? "0.5rem" : _props$spacing2,
    isAttached = props.isAttached,
    isDisabled = props.isDisabled,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation,
    rest = _objectWithoutProperties(props, _excluded4);
  var _className = (0, import_shared_utils4.cx)("chakra-button__group", className);
  var context = (0, import_react5.useMemo)(function () {
    return {
      size: size,
      colorScheme: colorScheme,
      variant: variant,
      isDisabled: isDisabled
    };
  }, [size, colorScheme, variant, isDisabled]);
  var groupStyles = _objectSpread({
    display: "inline-flex"
  }, isAttached ? attachedStyles[orientation] : gapStyles[orientation](spacing));
  var isVertical = orientation === "vertical";
  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(ButtonGroupProvider, {
    value: context,
    children: /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system4.chakra.div, _objectSpread({
      ref: ref,
      role: "group",
      __css: groupStyles,
      className: _className,
      "data-attached": isAttached ? "" : void 0,
      "data-orientation": orientation,
      flexDir: isVertical ? "column" : void 0
    }, rest))
  });
});
_ButtonGroup.displayName = "ButtonGroup";

// src/icon-button.tsx
var import_system5 = require("@chakra-ui/system");
var import_react6 = require("react");
var import_jsx_runtime5 = require("react/jsx-runtime");
var _IconButton = (0, import_system5.forwardRef)(function (props, ref) {
  var icon = props.icon,
    children = props.children,
    isRound = props.isRound,
    ariaLabel = props["aria-label"],
    rest = _objectWithoutProperties(props, _excluded5);
  var element = icon || children;
  var _children = (0, import_react6.isValidElement)(element) ? (0, import_react6.cloneElement)(element, {
    "aria-hidden": true,
    focusable: false
  }) : null;
  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(_Button, _objectSpread(_objectSpread({
    padding: "0",
    borderRadius: isRound ? "full" : void 0,
    ref: ref,
    "aria-label": ariaLabel
  }, rest), {}, {
    children: _children
  }));
});
_IconButton.displayName = "IconButton";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Button: _Button,
  ButtonGroup: _ButtonGroup,
  ButtonSpinner: _ButtonSpinner,
  IconButton: _IconButton,
  useButtonGroup: _useButtonGroup
});